// Pathify
import { make } from 'vuex-pathify'

// Data
const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/admin/dashboard',
    },
    {
      title: 'تعریف انواع وام',
      icon: 'mdi-chart-bubble',
      to: '/admin/loans/',
      claim: 'Loans'
    },
    {
      title: 'لیست مشتریان',
      icon: 'mdi-account-multiple',
      to: '/admin/members/',
      claim: 'Members'
    },
    {
      title: 'اعلام واریز ها',
      icon: 'mdi-account-multiple',
      to: '/admin/loanPaymentRequests',
      claim: 'PaymentRequests'
    },
    {
      title: 'مدیریت پیامک و ایمیل',
      icon: 'mdi-message',
      to: '/admin/smslist',
      part: 'sms',
    },
     {
      title: 'مدیریت استعلام ها',
      icon: 'mdi-bandage',
      to: '/admin/inquirymanagement',
      part: 'inquiry',
      claim: 'Inquiry'
    },
    {
      title: 'درخواست وام ها',
      icon: 'mdi-bell',
      to: '/admin/userLoanRequests/',
      part: 'loanRequest',
      claim: 'LoanRequests'
    },
    {
      title: 'نماینده ها',
      icon: 'mdi-face-agent',
      to: '/admin/agents/',
      claim: 'Agents',
      part: 'agent'
    },
    {
      title: 'طرف حساب ها',
      icon: 'mdi-account-badge',
      to: '/admin/contacts/',
      claim: 'Contacts',
      part: 'contact'
    },
    {
      title: 'بازاریاب ها',
      icon: 'mdi-account-badge',
      to: '/admin/marketers/',
      claim: 'Marketers',
      part: 'customerMarketer'
    },
    {
      title: 'تیکت ها',
      icon: 'mdi-email-fast',
      to: '/admin/tickets/',
      claim: 'Tickets',
      part: 'ticket'
    },
    {
      title: 'سفارش خریدها',
      icon: 'mdi-cart',
      to: '/admin/customerOrders/',
      claim: 'CustomerOrders',
    },
    {
      title: 'گزارش ها',
      icon: 'mdi-format-list-numbered-rtl',
      to: '/admin/reports/',
      claim: 'Reports'
    },
    {
      title: 'کاربران',
      icon: 'mdi-account',
      to: '/admin/users/',
      claim: 'Users'
    },
  ],
  memberItems: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/member/dashboard',
    },
    {
      title: 'لیست وام ها',
      icon: 'mdi-account-multiple',
      to: '/member/loans/',
    },
    {
      title: 'اعلام واریزی ها',
      icon: 'mdi-account-multiple',
      to: '/member/loanPaymentRequests',
    },
    {
      title: 'درخواست وام',
      icon: 'mdi-bell',
      to: '/member/loanRequest/',
    },
    {
      title: 'اعتبارسنجی',
      icon: 'mdi-credit-card-lock',
      to: '/member/iranValidityReports/',
    },
    {
      title: 'تیکت ها (پیام به پشتیبانی)',
      icon: 'mdi-email-fast',
      to: '/member/tickets/',
      part: 'ticket'
    },
    {
      title: 'صورتحساب های الکترونیکی',
      icon: 'mdi-invoice',
      to: '/member/agentFactors/',
      part: 'agentFactor'
    }
  ],
  superAdminItems: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/superAdmin/dashboard',
    },
    {
      title: 'قالب های پیامک',
      icon: 'mdi-message-processing',
      to: '/superAdmin/smsPatterns/',
    },
    {
      title: 'مشتری ها',
      icon: 'mdi-account-multiple',
      to: '/superAdmin/customers',
    },
    {
      title: 'تیکت ها',
      icon: 'mdi-email-fast',
      to: '/superAdmin/tickets',
    },
    {
      title: 'بازاریاب ها',
      icon: 'mdi-account-badge',
      to: '/superAdmin/marketers',
    },
    {
      title: 'درخواست مشاوره ها',
      icon: 'mdi-help',
      to: '/superAdmin/consultants',
    },
    {
      title: 'تراکنش ها',
      icon: 'mdi-shopping',
      to: '/superAdmin/purchases',
    },
    {
      title: 'مدیریت استعلام ها',
      icon: 'mdi-bandage',
      to: '/superAdmin/inquirymanagement',
    },
    {
      title: 'مدیریت پیامک ها',
      icon: 'mdi-message',
      to: '/superAdmin/smsmanagement',
    }
  ],
  agentItems: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/agent/dashboard',
    },
    {
      title: 'مشتری ها',
      icon: 'mdi-account-multiple',
      to: '/agent/customers',
    },
    {
      title: 'درخواست وام ها',
      icon: 'mdi-folder-account',
      to: '/agent/loanRequests/',
    },
    {
      title: 'واریزی های اسپانسر',
      icon: 'mdi-folder-account',
      to: '/agent/sponsorePayments/',
      // alias: 'sponsorePayments'
    },
    {
      title: 'نماینده ها (زیر مجموعه ها)',
      icon: 'mdi-face-agent',
      to: '/agent/agents/',
      // alias: 'agents'
    },
    {
      title: 'تسویه ها',
      icon: 'mdi-credit-card-outline',
      to: '/agent/subAgentTransactions/',
      // alias: 'subAgentTransactions'
    },
    {
      title: 'تیکت ها',
      icon: 'mdi-email-fast',
      to: '/agent/tickets/',
      part: 'ticket'
    },
    {
      title: 'صورتحساب های الکترونیکی',
      icon: 'mdi-invoice',
      to: '/agent/agentFactors/',
      part: 'agentFactor'
    }
  ],
  customerMarketerItems: [
    {
      title: 'داشبورد',
      icon: 'mdi-view-dashboard',
      to: '/customerMarketer/dashboard',
    },
  ]
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
